import { HistoryIcon } from '@tiendanube/icons';
import { ActionIconButton } from 'commons/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';

interface IconButtonStockHistoryProps {
  onClick: () => void;
}

function IconButtonStockHistory({
  onClick,
}: IconButtonStockHistoryProps): JSX.Element {
  const t = useTranslationCatalog();

  return (
    <ActionIconButton
      content={t('products.detail.goToStockHistory')}
      source={<HistoryIcon />}
      onClick={onClick}
    />
  );
}

export default IconButtonStockHistory;
